export class GoogleAnalyticsSetupService {

    constructor($q) {
        'ngInject';

        this.dfd = $q.defer();
    }

    getMetadata() {
        return this.dfd.promise;
    }

    setMetadata({ trackingId, sampleRate }) {
        this.dfd.resolve({ trackingId, sampleRate });
    }

}
